// extracted by mini-css-extract-plugin
module.exports = {"button":"src-components-atoms-Button-___style__button___7GmPe"};